let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("e2KSr")).then(() => parcelRequire('864s3'));